import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import {downloadFile, getAxiosResponse, handleError} from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import Constants from "../../Constants";
import { PieChart } from "react-minimal-pie-chart";
import { RotatingLines } from "react-loader-spinner";
import $ from "jquery";
import {transformBlankToNull, getRandomColor, isEmptyString} from "../../services/Util";
import { useSelector } from "react-redux";
import DataTable, { createTheme } from "react-data-table-component";
import CustomToolTips from "../../components/global/CustomToolTips";
import { ConditionalBlock } from "../../ConditionalBlock";
import {IInfoIcon, CrossButtonIcon, ExportIcon, SimpleFileIcon} from "../../AppIcons";
import dateUtil, {DATE_FORMATS} from "../../services/DateUtil";
import Filters, {FilterType} from "./filters/Filters";
import ReviewersDownloadPopup from "./ReviewersDownloadPopup";
import ReviewersSendMail from "./ReviewersSendMail";
import SuccessMessage from "../../components/SuccessMessage";

export default function ProjectDashboardReports(props) {
  const { t } = useTranslation();
  const translate = t;
  const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
  const theme = aaaSelected ? "dark" : "";
  const paginationRef = useRef();
  const projectStatusTooltipRef = useRef(null);
  const deliveryStatusTooltipRef = useRef(null);
  const reviewerReportTooltipRef = useRef(null);
  const languageStatusTooltipRef = useRef(null);
  const assetByLanguageTooltipRef = useRef(null);
  const workflowTooltipRef = useRef(null);
  const [downloadInProgress, setDownloadInProgress] = useState(false);
  const [projectByStatusFilters, setProjectByStatusFilters] = useState("");
  const [reviewerFeedbackFilters, setReviewerFeedbackFilters] = useState(""); // query params
  const [reviewerFeedbackFiltersJson, setReviewerFeedbackFiltersJson] = useState(""); // json
  const [projectByLangFilters, setProjectByLangFilters] = useState("");
  const [projectByWorkflowFilters, setProjectByWorkflowFilters] = useState("");
  const [showMessage, setShowMessage] = useState(false)

  const efficiencyOptions = [
    { value: "Project Efficiency", label: "Project Efficiency" },
    { value: "Review Efficiency", label: "Reviewer Efficiency" },
    { value: "Translation Efficiency", label: "Translation Efficiency" },
  ];

  const languageStatusOptions = [
    { value: "", label: "Project Status - All" },
    { value: "projectStatusCanceled", label: translate("report.project_dashboard.project_status.projectStatusCanceled") },
    { value: "projectStatusClosed", label: translate("report.project_dashboard.project_status.projectStatusClosed") },
    { value: "projectStatusInReview", label: translate("report.project_dashboard.project_status.projectStatusInReview") },
    { value: "projectStatusWaitingForBidSelection", label: translate("report.project_dashboard.project_status.projectStatusWaitingForBidSelection") },
    { value: "projectStatusWaitingForMachineTranslation", label: translate("report.project_dashboard.project_status.projectStatusWaitingForMachineTranslation") },
    { value: "projectStatusInTranslation", label: translate("report.project_dashboard.project_status.projectStatusInTranslation") },
    { value: "projectStatusAllTranslationApproved", label: translate("report.project_dashboard.project_status.projectStatusAllTranslationApproved") },
    { value: "projectStatusInCreation", label: translate("report.project_dashboard.project_status.projectStatusInCreation") },
    { value: "projectStatusWaitingForVendorAcceptance", label: translate("report.project_dashboard.project_status.projectStatusWaitingForVendorAcceptance") },
  ];

  const defaultLabelStyle = {
    fontSize: "4px",
    fontFamily: "sans-serif",
    fill: "#FFFFFF",
  };

  const deliveryStatusColorCode = [
    { value: "COMPLETED", colorCode: "#457F88" },
    { value: "ON_TRACK", colorCode: "#5AA82A" },
    { value: "LATE", colorCode: "#BD0B0B" },
    { value: "AT_RISK", colorCode: "#E1A10C" },
    { value: "CANCELLED", colorCode: "#457F88" },
    { value: "UNKNOWN", colorCode: "#E1A10C" },
  ];

  const handleSort = async (column, sortDirection) => {
    $(".rdt_TableCol_Sortable[data-column-id='" + column.id + "']").attr({
      "aria-label": column.name,
      "aria-sort": sortDirection.toUpperCase() === Constants.DESC ? Constants.DESCENDING : Constants.ASCENDING,
    });
  };

  const noDataFoundComponent = () => {
    return (
      <div role="rowgroup">
        <div role="row" className="no-data-display align-center">
          <div role="cell">
            <i className="nodata-icon"></i>
            <p>{Constants.NO_RECORD_FOUND}</p>
          </div>
        </div>
      </div>
    );
  };

  const reviewerReportColumns = [
    {
      id: "report.name",
      name: "Name",
      selector: (report) => report.name,
      sortable: true,
      cell: (report) => report.name,
    },
    {
      id: "report.edit",
      name: "Edits",
      wrap: true,
      subHeaderWrap: true,
      center: true,
      sortable: true,
      align: "right",
      width: "100px",
      selector: (report) => report.edits,
      cell: (report) => report.edits,
    },
    {
      id: "report.feedback",
      name: "Feedbacks",
      wrap: true,
      subHeaderWrap: true,
      center: true,
      sortable: true,
      align: "right",
      width: "130px",
      selector: (report) => report.feedbacks,
      cell: (report) => report.feedbacks,
    },
  ];

  const reviewerEditReportColumns = [
    {
      id: "report.name",
      name: "Name",
      selector: (report) => report.name,
      sortable: true,
      cell: (report) => report.name,
    },
    {
      id: "report.edit",
      name: "Edits",
      wrap: true,
      subHeaderWrap: true,
      center: true,
      sortable: true,
      align: "right",
      width: "100px",
      selector: (report) => report.edits,
      cell: (report) => report.edits,
    }
  ];

  const reviewerFeedbackReportColumns = [
    {
      id: "report.name",
      name: "Name",
      selector: (report) => report.name,
      sortable: true,
      cell: (report) => report.name,
    },
    {
      id: "report.feedback",
      name: "Feedbacks",
      wrap: true,
      subHeaderWrap: true,
      center: true,
      sortable: true,
      align: "right",
      width: "130px",
      selector: (report) => report.feedbacks,
      cell: (report) => report.feedbacks,
    },
  ];

  const [reviewerAbortController, setReviewerAbortController] = useState(null);
  const [feedbackAbortController, setFeedbackAbortController] = useState(null);
  const [reviewerColumns, setReviewerColumns] = useState([]);

  const [projectStatus, setProjectStatus] = useState([]);
  const [projectStatusProjects, setProjectStatusProjects] = useState({});
  const [filteredprojectStatus, setFilteredProjectStatus] = useState([]);
  const [top5ProjectStatus, setTop5ProjectStatus] = useState([]);
  const [top5ProjectStatusCount, setTop5ProjectStatusCount] = useState(0);
  const [projectStatusLoading, setProjectStatusLoading] = useState(false);
  const [projectStatusCount, setProjectStatusCount] = useState([]);
  const [deliveryStatus, setDeliveryStatus] = useState([]);
  const [deliveryStatusLoading, setDeliveryStatusLoading] = useState(false);
  const [languageStatus, setLanguageStatus] = useState([]);
  const [languageStatusLoading, setLanguageStatusLoading] = useState(false);
  const [languageProjects, setLanguageProjects] = useState({});
  const [popupProjects, setPopupProjects] = useState([]);

  const [workflowStatusLoading, setWorkflowStatusLoading] = useState(true);
  const [workflowStatus, setWorkflowStatus] = useState([]);
  const [workflowProjects, setWorkflowProjects] = useState({});

  const [selectedLanguageStatusOption, setSelectedLanguageStatusOption] = useState("");
  const [assestByLanguageStatus, setAssestByLanguageStatus] = useState([]);
  const [assestByLanguageStatusLoading, setAssestByLanguageStatusLoading] = useState(false);
  const [feedBackReportData, setFeedBackReportData] = useState([]);
  const [reviewerReportData, setReviewerReportData] = useState([]);
  const [feedbackAndReviewData, setFeedbackAndReviewData] = useState([]);
  const [feedbackAndReviewDataLoading, setFeedbackAndReviewDataLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(50);
  const [selectedContentType, setSelectedContentType] = useState("");
  const ProjectStatusTabs = {
    PROJECT_STATUS: "project_status",
    DELIVERY_STATUS: "delivery_status",
    INVOICE_STATUS: "invoice_status"
  }
  const ReviewerTabs = {
    PROJECT: "Project",
    REVIEWER: "Reviewer"
  }
  const [activeProjectByStatusTab, setActiveProjectByStatusTab] = useState(ProjectStatusTabs.PROJECT_STATUS);
  const [loadedProjectByStatusTab, setLoadedProjectByStatusTab] = useState(ProjectStatusTabs.PROJECT_STATUS);
  const [activeReviewerTab, setActiveReviewerTab] = useState(ReviewerTabs.PROJECT);
  const [popupTitle, setPopupTitle] = useState("")
  const [columns, setColumns] = useState([])
  const [dataTableKey, setDataTableKey] = useState(1);


  const showWorkflowModel = (workflowLable) => {
    setPopupTitle("Project By Workflow: " + workflowLable)
    setColumns(workflowProjectColumns)
    setPopupProjects(workflowProjects.get(workflowLable));
    setDataTableKey(key => key + 1);
  };

  const showModel = (languageLabel) => {
    setPopupTitle("Project By Language: " + languageLabel)
    setColumns(projectByLangColumns)
    setPopupProjects(languageProjects.get(languageLabel));
    setDataTableKey(key => key + 1);
  };

  const showProjectStatusModel = (projectStatus) => {
    setPopupTitle("Project By Status: " + translate("report.project_dashboard." + activeProjectByStatusTab + "." + projectStatus))
    setColumns(projectColumns)
    setPopupProjects(projectStatusProjects.get(projectStatus));
    setDataTableKey(key => key + 1);
  };

  useEffect(() => {
    if (popupProjects?.length > 0) {
      document.body.classList.add("modal-open");
    }
  }, [popupProjects]);

  const hideModel = () => {
    document.body.classList.remove("modal-open");
    setPopupProjects([]);
    setDataTableKey(key => key + 1);
  };

  useEffect(() => {
    fetchReportData();
  }, []);

  useEffect(() => {
    if (props.selectedDepartment || props.selectedDateRange) {
      fetchReportData();
    }
  }, [props.selectedDepartment, props.selectedDateRange]);

  useEffect(() => {
    // apply only when there is some data in filters and date is selected.
    // works with default filter, if there is no filter selected it will not work.
    if(props.selectedDateRange && props.selectedDateRange.length > 0 && projectByLangFilters) {
      getLanguageStatus();
    }
  }, [projectByLangFilters, props.selectedDateRange, props.selectedDepartment]);

  useEffect(() => {
    if (selectedContentType) {
      getAssestByLanguageStatus();
    }
  }, [selectedContentType]);

  useEffect(() => {
    setReviewerAndFeedbackData();
  }, [feedBackReportData, reviewerReportData]);

  useEffect(() => {
    setReviewerAndFeedbackData();
  }, [activeReviewerTab]);

  useEffect(() => {
    if(props.selectedDateRange && props.selectedDateRange.length > 0 && projectByWorkflowFilters) {
      getWorkflowStatus();
    }
  }, [projectByWorkflowFilters, props.selectedDepartment, props.selectedDateRange]);

  const setReviewerAndFeedbackData = () => {
    if (reviewerReportData?.length > 0 || feedBackReportData?.length > 0) {
      let combinedArray = reviewerReportData.concat(feedBackReportData);
      let reviewAndFeedbacks = [];
      if (activeReviewerTab === ReviewerTabs.PROJECT) {
        combinedArray?.map((data) => {
          let editCount = data.totalEdits;
          let feedbackCount = data.totalFeedbacks;
          let reviewAndFeedback = reviewAndFeedbacks.find((object) => object.id === data.projectId && object.name === data.projectName);
          if (reviewAndFeedback) {
            reviewAndFeedback.edits += editCount;
            reviewAndFeedback.feedbacks += feedbackCount;
          } else {
            reviewAndFeedbacks.push({ columnName: "Project", id: data.projectId, name: data.projectName, edits: editCount, feedbacks: feedbackCount });
          }
        });
        setTotalRows(reviewAndFeedbacks.length);
      } else {
        const groupedData = combinedArray?.filter((obj) => obj.reviewerReportFields !== null)
        .reduce((acc, item) => {
          item.reviewerReportFields.filter(it=>it.translation!==null).forEach(({ reviewerName, translation: { tuId } }) => {
            if (!acc[reviewerName]) {
              acc[reviewerName] = [];
            }
            acc[reviewerName].push(tuId);
          });
        return acc;
        }, {});
        let reviewerArray = Object.keys(groupedData).map(reviewerName => ({
          reviewerName,
          totalEdits: groupedData[reviewerName].length
        }));
        const groupedCommentData = combinedArray?.filter((obj) => obj.reviewerReportFields !== null)
        .reduce((acc, item) => {
          item.reviewerReportFields.filter(it=>it.comment!==null).forEach(({ reviewerName, comment: { tuId } }) => {
            if (!acc[reviewerName]) {
              acc[reviewerName] = [];
            }
            acc[reviewerName].push(tuId);
          });
        return acc;
        }, {});
        let feedbackArray = Object.keys(groupedCommentData).map(reviewerName => ({
          reviewerName,
          totalFeedbacks: groupedCommentData[reviewerName].length
        }));
        combinedArray = reviewerArray?.concat(feedbackArray);
        combinedArray?.map((data) => {
          let editCount = data.totalEdits ? data.totalEdits : 0;
          let feedbackCount = data.totalFeedbacks ? data.totalFeedbacks : 0;
          let reviewAndFeedback = reviewAndFeedbacks?.find((object) => object.name === data.reviewerName);
          if (reviewAndFeedback) {
            reviewAndFeedback.edits += editCount;
            reviewAndFeedback.feedbacks += feedbackCount;
          } else {
            reviewAndFeedbacks.push({ columnName: "Reviewer", name: data.reviewerName, edits: editCount, feedbacks: feedbackCount });
          }
        });
      }
      setFeedbackAndReviewData(reviewAndFeedbacks);
      setTotalRows(reviewAndFeedbacks.length);
      setFeedbackAndReviewDataLoading(false);
    } else {
      setFeedbackAndReviewData([]);
      setFeedbackAndReviewDataLoading(false);
    }
  };

  const fetchReportData = () => {
    Promise.all([
      getDeliveryStatus(),
      getAssestByLanguageStatus(),
    ]).catch(handleError);
  };

  useEffect(() => {
    // apply only when there is some data in filters and date is selected.
    // works with default filter, if there is no filter selected it will not work.
    if(props.selectedDateRange && props.selectedDateRange.length > 0 && projectByStatusFilters) {
      switch (activeProjectByStatusTab) {
        case ProjectStatusTabs.PROJECT_STATUS:
          initProjectByStatus(APIUrls.PROJECT_STATUS_COUNT_REPORT).then(() => setLoadedProjectByStatusTab(ProjectStatusTabs.PROJECT_STATUS))
          break;
        case ProjectStatusTabs.DELIVERY_STATUS:
          initProjectByStatus(APIUrls.PROJECT_STATUS_DELIVERY_COUNT_REPORT).then(() => setLoadedProjectByStatusTab(ProjectStatusTabs.DELIVERY_STATUS))
          break;
        case ProjectStatusTabs.INVOICE_STATUS:
          initProjectByStatus(APIUrls.PROJECT_STATUS_INVOICE_COUNT_REPORT).then(() => setLoadedProjectByStatusTab(ProjectStatusTabs.INVOICE_STATUS))
          break;
      }
    }
  }, [activeProjectByStatusTab, projectByStatusFilters, props.selectedDepartment, props.selectedDateRange]);

  const combinePageFilters = (filters) => {
    let combinedParams = props.params ? (props.params + "&") : "?";
    let date = `createdDateRangeStart=${props.startDate}&createdDateRangeEnd=${props.endDate}`;
    combinedParams += date + "&" + filters;
    return combinedParams
  }

  const getInvoiceNoActionRecords = (projectStatus) => {
    return projectStatus.find(p => p.title === Constants.SUBSCRIBER_INVOICE_STATUS.customer_invoice_no_action)?.data || [];
  };
  
  const segregateInvoiceRecords = (invoiceNoActionRecords) => {
    const projectsWithoutInvoiceStatus = [];
    const projectsWithNoActionInvoiceStatus = [];
  
    invoiceNoActionRecords?.forEach(p => {
      if (p.customerBillingStatus === null) {
        projectsWithoutInvoiceStatus.push(p);
      } else if (p.customerBillingStatus === Constants.SUBSCRIBER_INVOICE_STATUS.customer_invoice_no_action) {
        projectsWithNoActionInvoiceStatus.push(p);
      }
    });
  
    return { projectsWithoutInvoiceStatus, projectsWithNoActionInvoiceStatus };
  };
  
  const updateFilteredData = (filteredData, projectStatus) => {
    const index = filteredData?.findIndex(record => record.title === Constants.SUBSCRIBER_INVOICE_STATUS.customer_invoice_no_action);
    if (index !== -1 && projectStatus) {
      const invoiceNoActionRecords = getInvoiceNoActionRecords(projectStatus);
      const { projectsWithoutInvoiceStatus, projectsWithNoActionInvoiceStatus } = segregateInvoiceRecords(invoiceNoActionRecords);
  
      filteredData[index] = {
        title: Constants.SUBSCRIBER_INVOICE_STATUS.customer_invoice_no_action,
        value: projectsWithNoActionInvoiceStatus.length,
        color: getRandomColor(),
        data: projectsWithNoActionInvoiceStatus
      };
  
      if (projectsWithoutInvoiceStatus.length > 0) {
        filteredData.push({
          title: Constants.DELIVERY_STATUS_UNKNOWN,
          value: projectsWithoutInvoiceStatus.length,
          color: getRandomColor(),
          data: projectsWithoutInvoiceStatus
        });
      }
    }
    return filteredData;
  };
  
  const updateProjectStatusProjects = (projectStatusProjects, projectStatus) => {
    if (projectStatusProjects?.has(Constants.SUBSCRIBER_INVOICE_STATUS.customer_invoice_no_action) && projectStatus) {
      const invoiceNoActionRecords = getInvoiceNoActionRecords(projectStatus);
      const { projectsWithoutInvoiceStatus, projectsWithNoActionInvoiceStatus } = segregateInvoiceRecords(invoiceNoActionRecords);
  
      projectStatusProjects?.set(Constants.SUBSCRIBER_INVOICE_STATUS.customer_invoice_no_action, projectsWithNoActionInvoiceStatus);
      if (projectsWithoutInvoiceStatus.length > 0) {
        projectStatusProjects?.set(Constants.DELIVERY_STATUS_UNKNOWN, projectsWithoutInvoiceStatus);
      }
    }
    return projectStatusProjects;
  };

  const initProjectByStatus = (url) => {
    setProjectStatusLoading(true);
    return getAxiosResponse(url + combinePageFilters(projectByStatusFilters))
      .then((res) => {
        setProjectStatusLoading(false);
        var localCount = 0;
        if (res.data?.code === 200) {
          let projectStatus = transformBlankToNull(res.data?.data?.report);
          projectStatus?.map((data) => {
            localCount += data?.value;
            data.color = getRandomColor();
          });
          let filteredData = projectStatus ? projectStatus.filter((p) => p.title !== "" && p.title !== null) : projectStatus;
          setProjectStatus(filteredData);
          let projectStatusprojects = filteredData?.reduce((acc, obj) => {
            return acc.set(obj.title, obj.data);
          }, new Map());
          projectStatusprojects = updateProjectStatusProjects(projectStatusprojects, projectStatus);
          setProjectStatusProjects(projectStatusprojects);
          filteredData = updateFilteredData(filteredData, projectStatus);
          setFilteredProjectStatus(filteredData);
          setProjectStatusCount(localCount);

          if(filteredData !== null) {
            let top5Arr = filteredData.slice(0, 5);
            setTop5ProjectStatus(top5Arr);
            let top5Count = 0;
            top5Arr?.map(data => top5Count += data?.value);
            setTop5ProjectStatusCount(top5Count);
          } else {
            setTop5ProjectStatus([])
            setTop5ProjectStatusCount(0)
          }
        }
      }).catch((err) => {
        handleError(err);
        setProjectStatusLoading(false);
      });
  };

  useEffect(() => {
    if(props.selectedDateRange && props.selectedDateRange.length > 0) {
        getFeedBackReportStatus();
        getReviewerReportStatus();
    }
  }, [reviewerFeedbackFilters, props.selectedDateRange, props.selectedDepartment]);

  useEffect(() => {
    switch (reviewerFeedbackFiltersJson.editType) {
      case "FEEDBACK":
        setReviewerColumns(reviewerFeedbackReportColumns);
        break;
      case "EDITS":
        setReviewerColumns(reviewerEditReportColumns);
        break;
      default:
        setReviewerColumns(reviewerReportColumns);
        break;
    }
  }, [reviewerFeedbackFiltersJson]);

  const getDeliveryStatus = () => {
    setDeliveryStatusLoading(true);
    let date = `&createdDateRangeStart=${props.startDate}&createdDateRangeEnd=${props.endDate}`;
    getAxiosResponse(APIUrls.DELIVERY_STATUS_COUNT_REPORT + props.params + date)
      .then((res) => {
        setDeliveryStatusLoading(false);
        if (res.data?.code === 200) {
          let deliverySatus = transformBlankToNull(res.data?.data?.report);
          deliverySatus?.map((del) => {
            del.color = getRandomColor();
          });
          let filteredData = deliverySatus ? deliverySatus.filter((item) => item.title !== "CANCELLED" && item.title !== "COMPLETED") : deliverySatus;
          setDeliveryStatus(filteredData);
        }
      })
      .catch((err) => {
        setDeliveryStatusLoading(false);
        handleError(err);
      });
  };

  const getLanguageStatus = () => {
    setLanguageStatusLoading(true);
    getAxiosResponse(APIUrls.LANGUAGE_STATUS_COUNT_REPORT + combinePageFilters(projectByLangFilters))
      .then((res) => {
        setLanguageStatusLoading(false);
        if (res.data?.code === 200) {
          let languageStatus = transformBlankToNull(res.data?.data?.report);
          setLanguageStatus(languageStatus);

          let languageprojects = languageStatus?.reduce((acc, langObj) => {
            return acc.set(langObj.title, langObj.data);
          }, new Map());
          setLanguageProjects(languageprojects);
        }
      })
      .catch((err) => {
        handleError(err);
        setLanguageStatusLoading(false);
      });
  };

  const updateProjectWorkflowFilters = (projectByWorkflowFilters) => {
    const filters = new URLSearchParams(projectByWorkflowFilters);
    if (!filters.has(FilterType.WORKFLOWS)) {
      if (filters.has(FilterType.PROJECT_BY_WORKFLOW)) {
        const value = filters.get(FilterType.PROJECT_BY_WORKFLOW);
        filters.delete(FilterType.PROJECT_BY_WORKFLOW);
        filters.append(FilterType.WORKFLOWS, value);
      }
    }
    return filters.toString();
  };

  const getWorkflowStatus = () => {
    setWorkflowStatusLoading(true);
    let filters = updateProjectWorkflowFilters(projectByWorkflowFilters);
    getAxiosResponse(APIUrls.WORKFLOW_STATUS_REPORT + combinePageFilters(filters))
      .then((res) => {
        setWorkflowStatusLoading(false);
        if (res.data?.code === 200) {
          let wfStatus = transformBlankToNull(res.data?.data?.report);
          if(wfStatus && wfStatus.length > 0) {
            wfStatus = wfStatus.sort((a, b) => b.value - a.value);
          }
          setWorkflowStatus(wfStatus);

          let wfProjects = wfStatus?.reduce((acc, wfObj) => {
            let list = []
            if (wfObj.data) {
              let projectGroupData = Object.groupBy(wfObj.data, ({projectId}) => projectId)
              for (const projectId in projectGroupData) {
                let projectData = projectGroupData[projectId];
                let data = projectData[0]
                data.targetDisplayLanguage = projectData.map(obj => obj.targetDisplayLanguage).sort().join(", ")
                list.push(data)
              }
            }
            return acc.set(wfObj.title, list);
          }, new Map());
          setWorkflowProjects(wfProjects);
        }
      })
      .catch((err) => {
        handleError(err);
        setWorkflowStatusLoading(false);
      });
  };

  const getAssestByLanguageStatus = () => {
    setAssestByLanguageStatusLoading(true);
    let contentTypes = "";
    if (selectedContentType?.value) {
      contentTypes = `&contentTypes=${selectedContentType.value}`;
    }
    let date = `&createdDateRangeStart=${props.startDate}&createdDateRangeEnd=${props.endDate}&rangeStart=${props.startDate}&rangeEnd=${props.endDate}`;
    getAxiosResponse(APIUrls.ASSETS_BY_LANGUAGE_COUNT_REPORT + props.params + date + contentTypes)
      .then((res) => {
        setAssestByLanguageStatusLoading(false);
        if (res.data?.code === 200) {
          let assestByLanguages = transformBlankToNull(res.data?.data?.report);
          setAssestByLanguageStatus(assestByLanguages);
        }
      })
      .catch((err) => {
        setAssestByLanguageStatusLoading(false);
        handleError(err);
      });
  };

  const getFeedBackReportStatus = () => {
    setFeedbackAndReviewDataLoading(true);
    if(feedbackAbortController != null) {
      feedbackAbortController.abort();
    }
    let controller = new AbortController()
    setFeedbackAbortController(controller);
    let signal = controller.signal
    let date = `&rangeStart=${props.startDate}&rangeEnd=${props.endDate}&createdDateRangeStart=${props.startDate}&createdDateRangeEnd=${props.endDate}`;
    getAxiosResponse(APIUrls.FEEDBACK_REPORTS + props.params + date + "&" + reviewerFeedbackFilters, { signal })
      .then((res) => {
        if (res.data?.code === 200) {
          let feedbackReport = transformBlankToNull(res.data.data?.report);
          setFeedBackReportData(feedbackReport);
        }
      })
      .catch((err) => {
        setFeedbackAndReviewDataLoading(false);
        handleError(err);
      });
  };

  const getReviewerReportStatus = () => {
    setFeedbackAndReviewDataLoading(true);
    if(reviewerAbortController != null) {
      reviewerAbortController.abort();
    }
    let controller = new AbortController()
    setReviewerAbortController(controller);
    let signal = controller.signal
    let date = `&rangeStart=${props.startDate}&rangeEnd=${props.endDate}&createdDateRangeStart=${props.startDate}&createdDateRangeEnd=${props.endDate}`;
    getAxiosResponse(APIUrls.REVIEWER_REPORTS + props.params + date + "&" + reviewerFeedbackFilters, { signal })
      .then((res) => {
        if (res.data?.code === 200) {
          let reviewerReport = transformBlankToNull(res.data.data?.report);
          setReviewerReportData(reviewerReport);
        }
      })
      .catch((err) => {
        setFeedbackAndReviewDataLoading(false);
        handleError(err);
      });
  };

  const downloadCustomProjectStatusReport = () => {
    let url = APIUrls.PROJECT_STATUS_COUNT_REPORT_EXPORT + combinePageFilters(projectByStatusFilters);
    downloadReport(url, 'Project_Status.xlsx');
  }

  const downloadProjectFeedbackReport = () => {
    let date = `&createdDateRangeStart=${props.startDate}&createdDateRangeEnd=${props.endDate}&rangeStart=${props.startDate}&rangeEnd=${props.endDate}`;
    if(reviewerFeedbackFilters) {
      date += `&${reviewerFeedbackFilters}`;
    }
    let url = APIUrls.FEEDBACK_REPORTS_EXPORT + props.params + date;
    downloadReport(url, 'Project_Feedback.xlsx');
  }

  const sendProjectReviewerkReport = () =>{       
        let sendReportUrl = APIUrls.SEND_REVIEWER_REPORT(props.startDateOriginalFormat,props.endDateOriginalFormat);
        if(props.selectedDepartment?.value){
          sendReportUrl = sendReportUrl + `&groupId=${props.selectedDepartment?.value}`
        }
        if(reviewerFeedbackFilters){
          sendReportUrl = sendReportUrl + '&' +reviewerFeedbackFilters
        }
        setDownloadInProgress(true);
        setShowMessage(true);
          setTimeout(()=>{
            setShowMessage(false);
            setDownloadInProgress(false);   
          },2000)
        
         getAxiosResponse(sendReportUrl);
  } 

  const downloadProjecReviewerkReport = () => {
    let date = `&createdDateRangeStart=${props.startDate}&createdDateRangeEnd=${props.endDate}&rangeStart=${props.startDate}&rangeEnd=${props.endDate}`;
    if(reviewerFeedbackFilters) {
      date += `&${reviewerFeedbackFilters}`;
    }
    let url = APIUrls.REVIEWER_REPORTS_EXPORT + props.params + date;
    downloadReport(url, 'Reviewer_Status.xlsx');
  }

  const downloadProjectByLangReport = () => {
    let url = APIUrls.LANGUAGE_STATUS_COUNT_REPORT_EXPORT + combinePageFilters(projectByLangFilters);
    downloadReport(url, 'Project_Status.xlsx');
  }

  const downloadWorkflowReport = () => {
    let filters = updateProjectWorkflowFilters(projectByWorkflowFilters);
    let url = APIUrls.WORKFLOW_STATUS_REPORT_EXPORT + combinePageFilters(filters);
    downloadReport(url, 'Workflow_Time_Efficiency.xlsx');
  }

  const downloadReport = (url, reportName) => {
    setDownloadInProgress(true);
    downloadFile(url, reportName)
        .then((res) => {
          setDownloadInProgress(false);
        })
        .catch(err => {
          setDownloadInProgress(false);
          handleError(err);
        });
  }

  const [showContent, setShowContent] = useState(false);
  const toggleContent = () => {
    setShowContent(!showContent);
  };

  const cellWithTitle = (content) => {
    return <p title={content}>{content}</p>
  }
  const sortAmount = (rowA, rowB, direction) => {
    const parseAmount = (amount) => amount ? parseFloat(amount.replace(/[^0-9.-]+/g, Constants.BLANK)) : null;
    const a = typeof rowA === "number" ? rowA : parseAmount(rowA);
    const b = typeof rowB === "number" ? rowB : parseAmount(rowB);
    // const b = parseAmount(rowB);
    if (a === null || b === null) {
      return a === null ? -1 : 1;
    }
    if (a === 0 || b === 0) {
      return a === 0 ? -1 : 1;
    }
    return direction === Constants.ASC ? b - a : a - b;
  }

  const sortString = (rowA, rowB, direction) => {
    const getStringValue = (value) => {
      return value === null || value === undefined ? null : value.toLowerCase();
    };

    const a = getStringValue(rowA);
    const b = getStringValue(rowB);

    if (isEmptyString(a) && isEmptyString(b)) return 0;
    if(isEmptyString(a)) return -1;
    if(isEmptyString(b)) return 1;

    if (a < b) return direction === Constants.ASC ? 1 : -1;
    if (a > b) return direction === Constants.ASC ? -1 : 1;

    return 0;
  };

  const projectColumns = [
    {
      id: "project.name",
      name: translate("project_listing.project_name"),
      selector: row => datatableSelectorFormat(row.projectName),
      cell: (row) => cellWithTitle(row.projectName),
      sortFunction: (rowA, rowB, direction) => sortString(rowA.projectName, rowB.projectName, direction),
      sortable: true,
    },
    {
      id: "project.status",
      name: translate("project_listing.status"),
      selector: row => datatableSelectorFormat(row.status?.display),
      cell: (row) => cellWithTitle(row.status?.display),
      sortFunction: (rowA, rowB, direction) => sortString(rowA.status?.display, rowB.status?.display, direction),
      sortable: true
    },
    {
      id: "project.deliveryStatus",
      name: translate("project_listing.delivery_status"),
      selector: row => datatableSelectorFormat(row.deliveryStatus),
      cell: (row) => cellWithTitle(Constants.PROJECT_DELIVERY_STATUS[row.deliveryStatus]),
      sortFunction: (rowA, rowB, direction) => sortString(Constants.PROJECT_DELIVERY_STATUS[rowA.deliveryStatus], Constants.PROJECT_DELIVERY_STATUS[rowB.deliveryStatus], direction),
      sortable: true
    },
    {
      id: "project.created_on",
      name: "Created Date",
      selector: row => dateUtil.getDateTimestamp(row.createdDate),
      cell: (row) => cellWithTitle(dateUtil.format(row.createdDate, DATE_FORMATS.DATE_TIME)),
      sortFunction: (rowA, rowB, direction) => sortAmount(dateUtil.getDateTimestamp(rowA.createdDate), dateUtil.getDateTimestamp(rowB.createdDate), direction),
      sortable: true
    },
    {
      id: "project.firstTranslationDueDate",
      name: translate("project_listing.first_translation_due_date"),
      selector: row => "" + dateUtil.getDateTimestamp(row.requestedDate),
      cell: (row) => cellWithTitle(dateUtil.format(row.requestedDate, DATE_FORMATS.DATE_TIME)),
      sortFunction: (rowA, rowB, direction) => sortAmount(dateUtil.getDateTimestamp(rowA.requestedDate), dateUtil.getDateTimestamp(rowB.requestedDate), direction),
      sortable: true,
    },
    {
      id: "project.allTranslationDeliveredDate",
      name: "All Languages Delivered Date",
      selector: (row) => "" + dateUtil.getDateTimestamp(row.lastVendorSubmitDate),
      cell: (row) => cellWithTitle(dateUtil.format(row.lastVendorSubmitDate, DATE_FORMATS.DATE_TIME)),
      sortFunction: (rowA, rowB, direction) => sortAmount(dateUtil.getDateTimestamp(rowA.lastVendorSubmitDate), dateUtil.getDateTimestamp(rowB.lastVendorSubmitDate), direction),
      sortable: true
    },
    {
      id: "project.dueDate",
      name: translate("project_listing.due_date"),
      selector: (row) => "" + dateUtil.getDateTimestamp(row.dueDate),
      cell: (row) => cellWithTitle(dateUtil.format(row.dueDate, DATE_FORMATS.DATE_TIME)),
      sortFunction: (rowA, rowB, direction) => sortAmount(dateUtil.getDateTimestamp(rowA.dueDate), dateUtil.getDateTimestamp(rowB.dueDate), direction),
      sortable: true
    },
    {
      id: "project.allLanguageApprovedDate",
      name: translate("project_listing.all_language_approved_date"),
      selector: (row) => "" + dateUtil.getDateTimestamp(row.closedOrLastApprovedDate),
      cell: (row) => cellWithTitle(dateUtil.format(row.closedOrLastApprovedDate, DATE_FORMATS.DATE_TIME)),
      sortFunction: (rowA, rowB, direction) => sortAmount(dateUtil.getDateTimestamp(rowA.closedOrLastApprovedDate), dateUtil.getDateTimestamp(rowB.closedOrLastApprovedDate), direction),
      sortable: true
    },
    {
      id: "project.closedDate",
      name: "Closed Date",
      selector: (row) => "" + dateUtil.getDateTimestamp(row.closeDate),
      cell: (row) => cellWithTitle(dateUtil.format(row.closeDate, DATE_FORMATS.DATE_TIME)),
      sortFunction: (rowA, rowB, direction) => sortAmount(dateUtil.getDateTimestamp(rowA.closeDate), dateUtil.getDateTimestamp(rowB.closeDate), direction),
      sortable: true
    },
    {
      id: "project.amount",
      name: translate("project_listing.amount"),
      selector: (row) => row.customerAmountRaw ? row.customerAmountRaw : "",
      cell: (row) => cellWithTitle(row.customerAmountRaw),
      sortFunction: (rowA, rowB, direction) => sortAmount(rowA.customerAmountRaw, rowB.customerAmountRaw, direction),
      sortable: true
    },
  ];

  const workflowProjectColumns = [
    {
      id: "project.name",
      name: translate("project_listing.project_name"),
      selector: row => datatableSelectorFormat(row.projectName),
      cell: (row) => cellWithTitle(row.projectName),
      sortFunction: (rowA, rowB, direction) => sortString(rowA.projectName, rowB.projectName, direction),
      sortable: true,
    },
    {
      id: "project.sourceLanguage",
      name: translate("project_listing.source_language_label"),
      selector: row => datatableSelectorFormat(row.sourceDisplayLanguage),
      cell: (row) => cellWithTitle(row.sourceDisplayLanguage),
      sortFunction: (rowA, rowB, direction) => sortString(rowA.sourceDisplayLanguage, rowB.sourceDisplayLanguage, direction),
      sortable: true,
    },
    {
      id: "project.targetLanguage",
      name: translate("project_listing.target_language"),
      selector: row => datatableSelectorFormat(row.targetDisplayLanguage),
      cell: (row) => cellWithTitle(row.targetDisplayLanguage),
      sortFunction: (rowA, rowB, direction) => sortString(rowA.targetDisplayLanguage, rowB.targetDisplayLanguage, direction),
      sortable: true,
    },
  ]

  const projectByLangColumns = [
    {
      id: "project.name",
      name: translate("project_listing.project_name"),
      selector: row => datatableSelectorFormat(row.projectName),
      cell: (row) => cellWithTitle(row.projectName),
      sortFunction: (rowA, rowB, direction) => sortString(rowA.projectName, rowB.projectName, direction),
      sortable: true,
    },
    {
      id: "project.languageAmount",
      name: translate("project_listing.language_amount"),
      selector: row => row.languageAmount?.value,
      cell: (row) => cellWithTitle(row.languageAmount?.display),
      sortFunction: (rowA, rowB, direction) => sortAmount(dateUtil.getDateTimestamp(rowA.languageAmount?.value), dateUtil.getDateTimestamp(rowB.languageAmount?.value), direction),
      sortable: true,
    },
    {
      id: "project.language",
      name: translate("project_listing.language"),
      selector: row => datatableSelectorFormat(row.targetDisplayLanguage),
      cell: (row) => cellWithTitle(row.targetDisplayLanguage),
      sortFunction: (rowA, rowB, direction) => sortString(rowA.targetDisplayLanguage, rowB.targetDisplayLanguage, direction),
      sortable: true,
    },
      ...(projectColumns.slice(1))
  ]


  const datatableSelectorFormat = (input) => {
    return input ? input.toLowerCase().trim() : "";
  }

  return (
    <>
      <div className="flex">
        <div className="left-report p-0 w-d100">
          <div className="flex gap20">
            <div className="project-status report-border width-42">
              <div className="report-heading flex btn-gap mar-bot30">
                <h5 className="flex flex-nowrap">
                  <span> Project By Status </span>
                  <CustomToolTips
                      dataTip={Constants.PROJECT_DASHBOARD.PROJECT_STATUS_TOOLTIPS}
                      toolTipRef={projectStatusTooltipRef}
                      toolTipId="projectStatus"
                  />
                </h5>
                <div className="flex flex-align-center">
                  <div className="flex add-help-data">

                    <button title="Download" onClick={downloadCustomProjectStatusReport}>{ExportIcon}</button>
                    <Filters filterTypes={[
                      FilterType.PROJECT_STATUS,
                      FilterType.DELIVERY_STATUS,
                      FilterType.INVOICE_STATUS,
                      FilterType.SOURCE_LANGUAGE,
                      FilterType.TARGET_LANGUAGES,
                      FilterType.CURRENCY,
                      FilterType.VENDORS,
                      FilterType.REVIEWERS,
                      FilterType.WORKFLOWS,
                      FilterType.TAGS,
                      FilterType.INTENDED_USE]}
                             submitQueryParamsCallback={setProjectByStatusFilters}
                             defaultValues={{
                               [FilterType.CURRENCY]: {
                                 value: Constants.USD
                               }
                             }}
                             selectedDepartment={props.selectedDepartment?.value}/>
                    <div className="report-dot-dropdown hide">
                      <div className="dots" role="button" onClick={toggleContent}>
                        <span></span><span></span><span></span>
                        <div className={showContent ? "triangle-with-shadow show" : "hide"}></div>
                      </div>

                      <div className={showContent ? "popover-body show" : "popover-body"}>
                        <div className="inner-popover">
                          <div className="user-list"><a href="#">Project dashboard</a></div>
                          <div className="user-list"><a href="#">Operational Cost</a></div>
                          <div className="user-list"><a href="#">TM</a></div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <div className="report-heading btn-gap mar-bot30">
              <div className="listing-tab-block flex">
                  <ul className="listing-tab-link tab-style-2 flex">
                    <li>
                      <button className={activeProjectByStatusTab === ProjectStatusTabs.PROJECT_STATUS ? "active" : ""}
                              onClick={() => setActiveProjectByStatusTab(ProjectStatusTabs.PROJECT_STATUS)}>
                        Projects Status
                      </button>
                    </li>
                    <li>
                      <button className={activeProjectByStatusTab === ProjectStatusTabs.DELIVERY_STATUS ? "active" : ""}
                              onClick={() => setActiveProjectByStatusTab(ProjectStatusTabs.DELIVERY_STATUS)}>
                        Delivery Status
                      </button>
                    </li>
                    <li>
                      <button className={activeProjectByStatusTab === ProjectStatusTabs.INVOICE_STATUS ? "active" : ""}
                              onClick={() => setActiveProjectByStatusTab(ProjectStatusTabs.INVOICE_STATUS)}>
                        Invoice Status
                      </button>
                    </li>
                  </ul>
                </div>


              </div>
              {projectStatusLoading ? (
                  <div style={{textAlign: "center"}} className="flex-align-center loader-center">
                    <RotatingLines strokeColor="grey" strokeWidth="5" width="96" visible={true}/>
                  </div>
              ) : (
                  <>
                    <ConditionalBlock condition={projectStatusCount === 0}>
                      {noDataFoundComponent()}
                    </ConditionalBlock>
                    <ConditionalBlock condition={projectStatusCount > 0}>
                      <div className="pie-chart flex">
                        <div className="chartBox">
                          <div className="pieTotalCount">
                            <span>{projectStatusCount}</span>
                            <strong>Projects</strong>
                          </div>
                          <PieChart
                              radius={35}
                              data={top5ProjectStatus}
                              //onFocus={(e, segmentIndex)}
                              segmentsTabIndex={0}
                              center={[40, 50]}
                              viewBoxSize={[100, 100]}
                              lineWidth={40}
                              totalValue={top5ProjectStatusCount}
                              labelPosition={78}
                              label={({dataEntry}) => `${Math.floor(dataEntry.percentage)} %`}
                              labelStyle={{
                                ...defaultLabelStyle,
                              }}></PieChart>
                        </div>
                        <div className="clorList maxHeight380">
                          <ul>
                            {filteredprojectStatus?.map((data) => (
                                <li>
                                  <span style={{background: data.color}}> </span>
                                  <small>{data.value + " " + translate(`report.project_dashboard.${loadedProjectByStatusTab}.${data.title}`)}</small>
                                  <button onClick={() => showProjectStatusModel(data.title)}>
                                    {IInfoIcon}
                                  </button>
                                </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </ConditionalBlock>
                  </>
              )}
            </div>

            <div className="delivery-status report-border width-20">
              <div className="flex gap20 mar-bot25 report-heading">
                <h5 className="flex flex-nowrap">
                  <span>Open Projects Tracking</span>
                  <CustomToolTips dataTip={Constants.PROJECT_DASHBOARD.DELIVERY_STATUS_TOOLTIPS}
                                  toolTipRef={deliveryStatusTooltipRef} toolTipId="deliveryStatus"/>
                </h5>
              </div>
              {deliveryStatusLoading ? (
                  <div style={{textAlign: "center"}} className="flex-align-center loader-center">
                    <RotatingLines strokeColor="grey" strokeWidth="5" width="96" visible={true}/>
                  </div>
              ) : (
                  <ul className="report-order-list maxHeight380">
                    {deliveryStatus?.map((data) => (
                        <li>
                          <span>{translate("report.project_dashboard.delivery_status." + data?.title)}</span>
                          <strong style={{color: data?.color}}>{data?.value}</strong>
                        </li>
                    ))}
                  </ul>
              )}
            </div>

            <div className="report-border width-35">
              <div className="flex gap20 mar-bot25 report-heading">
                <h5 className="flex flex-nowrap">
                  <span>Reviewers Edits & Feedback</span>
                  <CustomToolTips dataTip={Constants.PROJECT_DASHBOARD.REVIEWER_REPORT_TOOLTIPS}
                                  toolTipRef={reviewerReportTooltipRef} toolTipId="reviewerReport"/>
                </h5>


                <div className="flex flex-align-center">
                  <div className="flex add-help-data">
                                                    
                    <ReviewersSendMail>
                      <ul>
                        <li>
                          <button title="Reviewer Report" className="multi-download-button" onClick={sendProjectReviewerkReport}>{SimpleFileIcon} Reviewer
                            Report
                          </button>
                        </li>                        
                      </ul>
                    </ReviewersSendMail>
                    
                    <ReviewersDownloadPopup>
                      <ul>
                        <li>
                          <button title="Reviewer Report" className="multi-download-button" onClick={downloadProjecReviewerkReport}>{SimpleFileIcon} Reviewer
                            Report
                          </button>

                        </li>
                        <li>
                          <button title="Feedback Report" className="multi-download-button" onClick={downloadProjectFeedbackReport}>{SimpleFileIcon} Feedback
                            Report
                          </button>
                        </li>
                      </ul>
                    </ReviewersDownloadPopup>

                    <Filters filterTypes={[FilterType.SOURCE_LANGUAGE,
                      FilterType.TARGET_LANGUAGES,
                      FilterType.PROJECT_STATUS,
                      FilterType.WORKFLOWS,
                      FilterType.CAMPAIGNS,
                      FilterType.EDIT_TYPE]
                    }
                             submitQueryParamsCallback={setReviewerFeedbackFilters}
                             submitJsonCallback={setReviewerFeedbackFiltersJson}
                             defaultValues={{
                               [FilterType.PROJECT_STATUS]: [{
                                 value: "ALL_TRANSLATION_APPROVED",
                               }, {
                                 value: "PROJECT_CLOSED",
                               },],
                               [FilterType.EDIT_TYPE]: {value: "ALL"}
                             }}
                             selectedDepartment={props.selectedDepartment?.value}/>

                  </div>

                </div>

              </div>
              {feedbackAndReviewDataLoading ? (
                  <div style={{textAlign: "center"}} className="flex-align-center loader-center">
                    <RotatingLines strokeColor="grey" strokeWidth="5" width="96" visible={true}/>
                  </div>
              ) : (<>
              <div className="report-heading btn-gap mar-bot30">
                <ConditionalBlock condition={reviewerFeedbackFiltersJson && reviewerFeedbackFiltersJson.projectStatusCodes && reviewerFeedbackFiltersJson.projectStatusCodes.sort().join(",") === 'ALL_TRANSLATION_APPROVED,PROJECT_CLOSED'}>
                  Showing projects with status "Closed" and "All Languages Approved". You can change this from filters.
                </ConditionalBlock>
              <div className="listing-tab-block flex">
                  <ul className="listing-tab-link tab-style-2 flex">
                    <li>
                      <button className={activeReviewerTab === ReviewerTabs.PROJECT ? "active" : ""}
                              onClick={() => setActiveReviewerTab(ReviewerTabs.PROJECT)}>
                        By Project
                      </button>
                    </li>
                    <li>
                      <button className={activeReviewerTab === ReviewerTabs.REVIEWER ? "active" : ""}
                              onClick={() => setActiveReviewerTab(ReviewerTabs.REVIEWER)}>
                        By Reviewer
                      </button>
                    </li>
                  </ul>
                </div>

              </div>

              <div className="flex gap20">
                <div className="datatable-block w-d100 maxHeight380">
                  <DataTable
                      columns={reviewerColumns}
                      data={feedbackAndReviewData}
                      defaultSortFieldId="report.edit"
                      defaultSortAsc={false}
                      fixedHeader="true"
                      fixedHeaderScrollHeight="750px"
                      noDataComponent={noDataFoundComponent()}
                      progressPending={feedbackAndReviewDataLoading}
                      pointerOnHover={true}
                      pagination
                      paginationTotalRows={totalRows}
                      paginationRowsPerPageOptions={[10, 20, 40, 50, 100, 200]}
                      responsive
                      striped
                  />
                </div>
              </div>

                  </> )}
            </div>

            <div className="left-report report-border width35-10">
              <div className="lang-status w-d100">
                <div className="flex gap20 mar-bot25 report-heading">
                  <h5 className="flex flex-nowrap">
                    <span>Projects By Language</span>
                    <CustomToolTips dataTip={Constants.PROJECT_DASHBOARD.LANGUAGE_STATUS_TOOLTIPS}
                                    toolTipRef={languageStatusTooltipRef} toolTipId="languageStatus"/>

                  </h5>

                  <div className="flex flex-align-center">
                    <div className="flex add-help-data">

                      <button title="Download" onClick={downloadProjectByLangReport}>{ExportIcon}</button>
                      <Filters filterTypes={[FilterType.PROJECT_STATUS,
                        FilterType.DELIVERY_STATUS,
                        FilterType.INVOICE_STATUS,
                        FilterType.SOURCE_LANGUAGE,
                        FilterType.TARGET_LANGUAGES,
                        FilterType.CURRENCY,
                        FilterType.VENDORS,
                        FilterType.REVIEWERS,
                        FilterType.WORKFLOWS,
                        FilterType.TAGS,
                        FilterType.INTENDED_USE]}
                               submitQueryParamsCallback={setProjectByLangFilters}
                               defaultValues={{
                                 [FilterType.CURRENCY]: {
                                   value: Constants.USD
                                 }
                               }}
                               selectedDepartment={props.selectedDepartment?.value}/>

                    </div>
                  </div>

                </div>
                {languageStatusLoading ? (
                    <div style={{textAlign: "center"}} className="flex-align-center loader-center">
                      <RotatingLines strokeColor="grey" strokeWidth="5" width="96" visible={true}/>
                    </div>
                ) : (
                    <>
                      <ConditionalBlock condition={languageStatus === null || languageStatus?.length === 0}>
                        {noDataFoundComponent()}
                      </ConditionalBlock>
                      <ConditionalBlock condition={languageStatus?.length > 0}>
                        <div className="lang-progress maxHeight380">
                        {languageStatus?.map((language) => {
                            return (
                                <div className="lang-progress-list flex">
                                  <div className="langtext">
                                    {language.title}
                                    <button onClick={() => showModel(language.title)}>
                                      {IInfoIcon}
                                    </button>
                                  </div>
                                  <div className="right flex-center">
                                    <strong>{language.value}</strong>
                                  </div>
                                </div>
                            );
                          })}
                        </div>
                      </ConditionalBlock>

                    </>
                )}
              </div>
            </div>

            <div className="right-status report-border width35-10">
              <div className="assests-lang">
                <div className="flex gap20 mar-bot25 report-heading">
                  <h5 className="flex flex-nowrap">
                    <span>Assets Count By Language</span>
                    <CustomToolTips dataTip={Constants.PROJECT_DASHBOARD.ASSET_BY_LANGUAGE_TOOLTIPS}
                                    toolTipRef={assetByLanguageTooltipRef} toolTipId="assetByLanguage"/>
                  </h5>
                  <div className="global-dropdown-block m-0">
                    <Select
                        className="global-dropdown-select"
                        menuShouldScrollIntoView={false}
                        closeMenuOnSelect={true}
                        classNamePrefix="cw"
                        options={props.contentTypes}
                        value={selectedContentType === "" ? props.contentTypes[0] : selectedContentType}
                        onChange={(event) => setSelectedContentType(event)}
                    />
                  </div>
                </div>
                {assestByLanguageStatusLoading ? (
                    <div style={{textAlign: "center"}} className="flex-align-center loader-center">
                      <RotatingLines strokeColor="grey" strokeWidth="5" width="96" visible={true}/>
                    </div>
                ) : (
                    <>
                      <ConditionalBlock
                          condition={assestByLanguageStatus === null || assestByLanguageStatus?.length === 0}>
                        {noDataFoundComponent()}
                      </ConditionalBlock>
                      <ConditionalBlock condition={assestByLanguageStatus?.length > 0}>
                        <div className="lang-progress maxHeight380">
                          {assestByLanguageStatus?.map((language) => {
                            return (
                                <div className="lang-progress-list flex">
                                  <div className="langtext">
                                    {language.title}
                                  </div>
                                  <div className="right flex-center">
                                    <strong>{language.value}</strong>
                                  </div>
                                </div>
                            );
                          })}
                        </div>
                      </ConditionalBlock>
                    </>

                )}
              </div>
            </div>


            <div className="right-status report-border width-28">
              <div className="lang-status w-d100">
                <div className="flex gap20 mar-bot25 report-heading">
                  <h5 className="flex flex-nowrap">
                    <span>Projects By Workflow</span>
                    <CustomToolTips dataTip={Constants.PROJECT_DASHBOARD.WORKFLOW_STATUS_TOOLTIPS}
                                    toolTipRef={workflowTooltipRef} toolTipId="workflowTooltip"/>

                  </h5>

                  <div className="flex flex-align-center">
                    <div className="flex add-help-data">

                      <button title="Download" onClick={downloadWorkflowReport}>{ExportIcon}</button>
                      <Filters
                          filterTypes={[
                            FilterType.SOURCE_LANGUAGE,
                            FilterType.TARGET_LANGUAGES,
                            FilterType.TAGS,
                            FilterType.PROJECT_BY_WORKFLOW
                          ]}
                          submitQueryParamsCallback={setProjectByWorkflowFilters}
                          defaultValues={{
                            [FilterType.PROJECT_BY_WORKFLOW]: {index: 0}
                          }}
                          selectedDepartment={props.selectedDepartment?.value}/>

                    </div>
                  </div>
                </div>
                {workflowStatusLoading ? (
                    <div style={{textAlign: "center"}} className="flex-align-center loader-center">
                      <RotatingLines strokeColor="grey" strokeWidth="5" width="96" visible={true}/>
                    </div>
                ) : (
                    <>
                      <ConditionalBlock condition={workflowStatus === null || workflowStatus?.length === 0}>
                        {noDataFoundComponent()}
                      </ConditionalBlock>
                      <ConditionalBlock condition={workflowStatus?.length > 0}>
                        <div className="lang-progress maxHeight380">
                          {workflowStatus?.map((workflow) => {
                            return (
                                <div className="lang-progress-list flex">
                                  <div className="langtext">
                                    {workflow.title}
                                    <button onClick={() => showWorkflowModel(workflow.title)}>
                                      {IInfoIcon}
                                    </button>
                                  </div>
                                  <div className="right flex-center">
                                    <strong>{workflow.value}</strong>
                                  </div>
                                </div>
                            );
                          })}
                        </div>
                      </ConditionalBlock>

                    </>
                )}
              </div>
            </div>

            <div className="right-status report-border width-28 hide">
              <div className="efficiency-box">
                <div className="flex gap20 mar-bot25 report-heading">
                  <h5>Efficiency</h5>
                  <div className="global-dropdown-block m-0">
                    <Select
                        className="global-dropdown-select"
                        menuShouldScrollIntoView={false}
                        closeMenuOnSelect={true}
                        classNamePrefix="cw"
                        defaultValue={{label: "Select"}}
                        options={efficiencyOptions}
                    />
                  </div>
                </div>
                <div className="clorList">
                  <ul>
                    <li>
                      <span style={{background: "rgb(116, 191, 72)"}}> </span>
                      <small>In Review</small>
                    </li>
                    <li>
                      <span style={{background: "#295477"}}> </span>
                      <small>Configured Project Name</small>
                    </li>
                    <li>
                      <span style={{background: "#D04A02"}}> </span>
                      <small>Project Closed</small>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="lightbox-panel report-project-name panel80">
        <div className="inner-lightbox-panel pb-0">
          <div className="modal-header flex">
            <strong>{popupTitle}</strong>
            <button className="close" aria-label="close popup" onClick={hideModel}>
              {CrossButtonIcon}
            </button>
          </div>
          <div className="lightbox-content padd-22">
            <DataTable
                key={dataTableKey}
                keyField="id"
                columns={columns}
                defaultSortFieldId="project.name"
                responsive
                striped
                pagination
                pointerOnHover={true}
                paginationTotalRows={popupProjects.length}
                paginationRowsPerPageOptions={[10, 20, 40, 50, 100, 200]}
                noDataComponent={noDataFoundComponent()}
                data={popupProjects}
                fixedHeader="true"
                fixedHeaderScrollHeight="750px"
            />
          </div>
        </div>
      </div>
      {showMessage && <SuccessMessage message={"Your Request has been processed and the report will be delivered to your Email shortly"}/>}
      <div className={downloadInProgress ? "gb-overlay show" : "gb-overlay hide"}>
        <div className="gb-loader">
          <RotatingLines strokeColor="#0096FF" strokeWidth="5" width="196" visible={true}/>
        </div>
      </div>
    </>
  );
}
